import {
  asBool,
  asNumber,
  cloneDoc,
  ensureObject,
  objectRecord,
  type ApprovalsConfigDoc,
} from '../../../lib/approvals-config-form-utils';
import {
  CheckboxField,
  FieldLabel,
  NumberInput,
  SectionBox,
} from '../../tenants/tenant-config-form/FormPrimitives';

interface MasterApprovalsDefaultsFormProps {
  doc: ApprovalsConfigDoc;
  onChange: (doc: ApprovalsConfigDoc) => void;
}

function updateDoc(
  onChange: (doc: ApprovalsConfigDoc) => void,
  doc: ApprovalsConfigDoc,
  mutator: (next: ApprovalsConfigDoc) => void,
) {
  const next = cloneDoc(doc);
  mutator(next);
  onChange(next);
}

export function MasterApprovalsDefaultsForm({ doc, onChange }: MasterApprovalsDefaultsFormProps) {
  const defaults = objectRecord(doc.defaults);

  return (
    <div className="space-y-4 text-sm">
      <SectionBox title="Approval defaults">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <FieldLabel label="Expiration (hours)" hint="Hours until an approval request expires">
            <NumberInput
              value={asNumber(defaults.expiration_hours, 24)}
              onChange={(v) =>
                updateDoc(onChange, doc, (n) => {
                  ensureObject(n, 'defaults').expiration_hours = v;
                })
              }
            />
          </FieldLabel>
          <div className="flex items-end pb-1">
            <CheckboxField
              label="Notify all eligible approvers by default"
              checked={asBool(defaults.notify_all_by_default, false)}
              onChange={(checked) =>
                updateDoc(onChange, doc, (n) => {
                  ensureObject(n, 'defaults').notify_all_by_default = checked;
                })
              }
            />
          </div>
        </div>
        <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-2">
          When notify-all is off, the requester selects approvers. Microsoft integration and consent are configured per tenant.
        </p>
      </SectionBox>
    </div>
  );
}
